export function showMessageFromRoute(location, setSnackbar) {
  if (location?.state?.message) {
    setSnackbar({
      open: true,
      message: location.state.message,
      severity: "success",
    });

    // clear state so message won't repeat
    window.history.replaceState({}, "");
  }
}
